import { createGlobalStyle as i } from "styled-components";
import { typographyClasses as r, inputBaseClasses as p } from "@mui/material";
import { styled as o } from "./styled2.mjs";
import { InputLabel as l } from "./index46.mjs";
import { pickersFadeTransitionGroupClasses as n } from "./pickersFadeTransitionGroupClasses.mjs";
import { pickersYearClasses as c } from "./pickersYearClasses.mjs";
import { dayPickerClasses as a } from "./dayCalendarClasses.mjs";
import { pickersDayClasses as t } from "./pickersDayClasses.mjs";
import { pickersLayoutClasses as d } from "./pickersLayoutClasses.mjs";
import { DatePicker as m } from "./DatePicker.mjs";
import { PickersDay as f } from "./PickersDay.mjs";
const w = o(l)`
	padding-bottom: ${({ theme: e }) => e.tokens.spacing[2]};
`, S = i`
    .${n.root} {
        .${r.root} {
            font-size: 14px;
            color: ${({ theme: e }) => e.palette.text.primary};
        }
    }

    .${c.root} button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        font-size: 20px;
    }

    .${a.header} {
        column-gap: ${({ theme: e }) => e.tokens.spacing[2]};
        display: flex;
        justify-content: center;
        align-items: flex-start;

        .${r.root} {
            color: ${({ theme: e }) => e.palette.text.secondary};

            width: 36px;
            height: 36px;
        }
    }

    .${t.root}  {
        font-size: 14px;
        font-weight: 400;

        &:hover, &:focus {
            border-radius: 50%;
            background: ${({ theme: e }) => e.palette.primary.main08};
        }

        &.${t.selected}  {
            border-radius: 50%;
            border-color: ${({ theme: e }) => e.palette.primary.main};
            color: ${({ theme: e }) => e.palette.background.level3};
        }

        &:not(.${t.selected}) {
            border-radius: 50%;
        }
    }

    .${d.root} {
        width: 340px;
        height: auto;
        border-radius: ${({ theme: e }) => e.tokens.radius[16]};
    }

    .${a.weekContainer} {
        column-gap: 2px;
    }
`, v = o(m)`
	.${p.adornedEnd} {
		padding-right: ${({ theme: e }) => e.spacing(2.75)};
	}
`, z = o(f)`
	${({ theme: e, $isSunday: s }) => ({
  ...s && {
    color: e.palette.text.disabled
  }
})};
`;
export {
  S as DatePickerGlobalStyle,
  w as OverLabel,
  v as StyledDatePicker,
  z as StyledPickersDay
};
//# sourceMappingURL=styles7.mjs.map
